import { useState } from 'react';

export default function Faq(props) {
    const [faqVisible, setFaqVisible] = useState(false);

    function toggleFaq() {
        setFaqVisible(!faqVisible);
    }

    return (
        <div style = {{textAlign: 'left'}}>
            <a style = {{fontWeight: '600', textAlign: 'left', fontSize: '24px'}} onClick={toggleFaq}>{props.question}</a>
            <div className = {`animated-height${faqVisible ? ' open' : ''}`}>
                {faqVisible &&
                    <p style = {{fontSize: '24px'}}>{props.answer}</p>
                }
            </div>
            <div style = {{height: '1px', width: '100%', backgroundColor: 'white', marginTop: '10px'}}></div>
        </div>
    )
}